var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 28,
  viewBox: "0 0 27 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 14,
  r: 12.7,
  stroke: "white",
  strokeWidth: 1.6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.6123 6.20996H15.1578C14.0728 6.20996 13.0322 6.65773 12.265 7.45476C11.4979 8.25179 11.0669 9.33279 11.0669 10.46V13.01H8.6123V16.41H11.0669V23.21H14.3396V16.41H16.7941L17.6123 13.01H14.3396V10.46C14.3396 10.2345 14.4258 10.0183 14.5792 9.85892C14.7327 9.69951 14.9408 9.60996 15.1578 9.60996H17.6123V6.20996Z",
  fill: "white"
})));
export default SvgIconFacebook;